/* eslint-disable no-magic-numbers */
import defaultHeaders from "../headers"
import client from "./client"
import { Response } from "../Model"

interface Logo {
    large?: string
    medium?: string
    small?: string
    thumbnail: string
    raw?: string
}

interface Union {
    logo: Logo
    about?: string[]
    email?: string
    website?: string
    fax?: string[] | null
    tel?: string[]
    address?: string
    name?: string
    code?: string
}

enum PaymentInstructionCode {
    Null = -1,
    OneTime = 1,
    Giro = 2,
    CreditCardRecurring = 3,
    CheckOff = 4,
    Sponsored = 5
}

interface MembershipDetailResponse {
    memberships: MembershipDetail[]
    vcCardNo: string
}
interface MembershipDetail {
    referralCode?: string
    campaignCode?: string
    lastPaymentEndDate: string
    lastPaymentStartDate: string
    showPaymentOption: boolean
    outstandingPaymentId?: string
    paymentMode: string
    paymentTypeName: string
    paymentType: number
    paymentModeName?: string
    paymentInstructionName?: string
    paymentInstructionCode: PaymentInstructionCode
    ucemMembershipGuid: string
    union: Union
    nameOnCard: string
    unionName: string
    unionCode: string
    status: string
    memberStartDate: string
    relationship?: string
    optInNebo?: boolean
    modifiedDttm: string
    modifiedBy?: string
    membershipTypeCode: string
    lastPaidDate?: string
    deletedDttm?: string
    deletedBy?: string
    createdDttm: string
    createdBy?: string
    id: number
}

const getMembershipDetails = () => client
    .get<Response<MembershipDetailResponse>>(`membership`, { headers: defaultHeaders() })
    .then(response => response.data)

export { getMembershipDetails }
export type { Logo, Union, MembershipDetail, MembershipDetailResponse }
export { PaymentInstructionCode }